module.exports = __webpack_public_path__ + "img/3.54ec102e.jpg";